import { isNil } from 'ramda';
import { parseXmlDate2 } from '../../../utility/date.helpers';
import { paramDate } from '../constants/parameterNames';
import { failure } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';

const optionalParameters = [
    {
        name: paramDate,
        description: "Date to return day of year for",
    },
];

const errorFailedToGetDay = "Failed to get day of year for date.";
const description = "Returns an integer value indicating the day number in the year for a date value. If no date parameter is provided, uses today’s date.";

const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;

function parseDateString(dateString) {
    const dateSpec = parseXmlDate2(dateString);

    if (!dateSpec) {
        throw new Error(`Invalid datetime value: ${dateString}`);
    }

    return dateSpec.date;
}

// Returns a Date object whose UTC time is the same as the current local time 
// (e.g.if the local time is 8 am Pacific, the value returned will be 8 am UTC)
function getCurrentLocalTimeAsUtc() {
    const d = new Date();

    return new Date(Date.UTC(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours(),
        d.getMinutes(),
        d.getSeconds(),
        d.getMilliseconds()
    ));
}

function execute({ parameters }) {
    const dateString = getParamValue(parameters, "date");

    //return error if dateString is empty
    if (!isNil(dateString) && dateString.trim() === '') {
        return failure(`/${paramDate} cannot be blank`);
    }

    try {
        const selectedDate = dateString
            ? parseDateString(dateString)
            : getCurrentLocalTimeAsUtc();

        selectedDate.setUTCHours(0);
        selectedDate.setUTCMinutes(0);
        selectedDate.setUTCSeconds(0);

        // The UTC date for the first day of the year in selectedDate
        const startDate = new Date(Date.UTC(selectedDate.getUTCFullYear()));
        const milliSeconds = selectedDate - startDate;

        if (Number.isNaN(milliSeconds)) {
            return failure(errorFailedToGetDay);
        }

        const dayOfYear = Math.round(milliSeconds / MILLISECONDS_IN_DAY);

        // BUGBUG - Why +1?
        return dayOfYear + 1;
    } catch (e) {
        return failure(errorFailedToGetDay + e.message);
    }
}

const GetDayOfYear = {
    description,
    optionalParameters,
    execute,
};

export default GetDayOfYear;